var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFullScreenExit = function SvgFullScreenExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    "data-name": "Group 6326"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6319"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.424 4.378 3.453 3.453-1.585.058a.77.77 0 1 0 .051 1.504l3.341-.045a.766.766 0 0 0 .748-.863l.109-3.32a.77.77 0 0 0-1.51-.06l-.058 1.586-3.424-3.424a.775.775 0 1 0-1.104 1.074Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.96 19.914-3.453-3.453-.061 1.589a.77.77 0 1 1-1.5-.055l.044-3.341a.766.766 0 0 1 .863-.748l3.32-.109a.77.77 0 0 1 .059 1.51l-1.586.059 3.424 3.424a.775.775 0 1 1-1.074 1.103Z",
    "data-name": "Undo"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6325"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.915 4.378-3.453 3.453 1.589.062a.77.77 0 1 1-.054 1.499l-3.342-.044a.766.766 0 0 1-.747-.863l-.11-3.32a.77.77 0 0 1 1.51-.059l.058 1.585 3.424-3.424a.775.775 0 1 1 1.103 1.075ZM5.378 19.913l3.453-3.452.058 1.585a.77.77 0 1 0 1.504-.052l-.046-3.34a.766.766 0 0 0-.863-.747l-3.32-.11a.77.77 0 0 0-.058 1.51l1.585.058-3.423 3.424a.775.775 0 1 0 1.074 1.103Z",
    "data-name": "Undo"
  })))));
};
export default SvgFullScreenExit;